"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EInvoicesAllowedScopes = void 0;
var EInvoicesAllowedScopes;
(function (EInvoicesAllowedScopes) {
    EInvoicesAllowedScopes["owner"] = "owner";
    EInvoicesAllowedScopes["customer"] = "customer";
    EInvoicesAllowedScopes["requisite"] = "requisite";
    EInvoicesAllowedScopes["company"] = "company";
    EInvoicesAllowedScopes["full"] = "full";
    EInvoicesAllowedScopes["awaitDocument"] = "awaitDocument"; // Ожидать создание документа при создании счета
})(EInvoicesAllowedScopes || (exports.EInvoicesAllowedScopes = EInvoicesAllowedScopes = {}));
//# sourceMappingURL=InvoicesAllowedScopes.enum.js.map